import {readCaptionTranslationRequest,type CaptionTranslationRequest} from './caption-translation-request';
import type {NativeWorkScope} from './native-envelope';

export type CaptionTranslationHostRequest={method:'POST';path:'/__waka/caption-translation'|'/__waka/caption-translation/lookup';body:CaptionTranslationRequest;params?:undefined};
export function isCaptionTranslationHostRequest(raw:unknown):raw is CaptionTranslationHostRequest{
 if(!raw||typeof raw!=='object'||Array.isArray(raw))return false;
 const value=raw as Record<string,unknown>;
 if(value.method!=='POST'||!['/__waka/caption-translation','/__waka/caption-translation/lookup'].includes(String(value.path))||value.params!==undefined||Object.keys(value).some(key=>!['method','path','body','params'].includes(key)))return false;
 try{readCaptionTranslationRequest(value.body);return true;}catch{return false;}
}
export function boundCaptionTranslationRequest(scope:NativeWorkScope,raw:unknown){
 const request=readCaptionTranslationRequest(raw);
 if(request.scope.projectId!==scope.projectId||request.scope.workId!==scope.workId||request.scope.surface!==scope.surface)throw Error('현재 편집 중인 작업의 번역만 요청할 수 있습니다.');
 return request;
}
export type CaptionTranslationReply={id:string;sourceHash:string}&(
 {status:'pending'}|{status:'needs-review';message:string}|{status:'completed';result:unknown}
);
export function readCaptionTranslationReply(raw:unknown,expected:CaptionTranslationRequest):CaptionTranslationReply{
 const record=(value:unknown):value is Record<string,unknown>=>!!value&&typeof value==='object'&&!Array.isArray(value);
 const fail=()=>{throw Error('다른 요청이거나 올바르지 않은 번역 응답입니다. 원문은 변경하지 않았습니다.');};
 if(!record(raw))return fail();
 if(JSON.stringify(readCaptionTranslationRequest(raw.request))!==JSON.stringify(readCaptionTranslationRequest(expected)))return fail();
 const job=raw.job;
 if(!record(job)||typeof job.id!=='string'||!/^[a-f0-9]{64}$/.test(job.id)||typeof job.sourceHash!=='string'||!/^[a-f0-9]{64}$/.test(job.sourceHash))return fail();
 const base={id:job.id,sourceHash:job.sourceHash};
 if(job.status==='pending')return {...base,status:'pending'};
 if(job.status==='needs-review')return {...base,status:'needs-review',message:'번역 완료 여부를 확인하지 못했습니다. 원문을 확인한 뒤 다시 시도해 주세요.'};
 // The editor validates every target/cue against its captured source plan before applying.
 if(job.status==='completed'&&record(job.result)&&Array.isArray(job.result.slots)&&Array.isArray(job.result.titles))return {...base,status:'completed',result:job.result};
 return fail();
}
